import { defineComponent as _defineComponent } from 'vue'
import { toRefs, watch, ref, computed } from '@nuxtjs/composition-api';

interface Props {
    trigger?: 'click' | 'hover' | 'focus' | 'manual';
    placement?: 'top' | 'top-start' | 'top-end' | 'bottom' | 'bottom-start' | 'bottom-end' | 'left' | 'left-start' | 'left-end' | 'right' | 'right-start' | 'right-end';
    width?: string | number;
    title?: string;
    content?: string;
    disabled?: boolean;
    offset?: number | string;
    transition?: string;
    popperClass?: string;
    openDelay?: number;
    closeDelay?: number;
    tabindex?: number;
    popperOptions?: object;
    value?: boolean;
    appendToBody?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Overlay',
  props: {
    trigger: { default: 'click' },
    placement: { default: 'left' },
    width: null,
    title: null,
    content: null,
    disabled: { type: Boolean, default: false },
    offset: null,
    transition: null,
    popperClass: null,
    openDelay: null,
    closeDelay: null,
    tabindex: null,
    popperOptions: null,
    value: { type: Boolean, default: false },
    appendToBody: { type: Boolean, default: true }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'input', value: boolean): void,
}), expose: any, slots: any, attrs: any }) {

const props = __props as { trigger: 'click' | 'hover' | 'focus' | 'manual', placement: 'top' | 'top-start' | 'top-end' | 'bottom' | 'bottom-start' | 'bottom-end' | 'left' | 'left-start' | 'left-end' | 'right' | 'right-start' | 'right-end', width?: string | number, title?: string, content?: string, disabled: boolean, offset?: number | string, transition?: string, popperClass?: string, openDelay?: number, closeDelay?: number, tabindex?: number, popperOptions?: object, value: boolean, appendToBody: boolean };





const {
    trigger,
    width,
    title,
    content,
    disabled,
    offset,
    transition,
    popperClass,
    openDelay,
    closeDelay,
    tabindex,
    popperOptions,
    value,
    placement,
    appendToBody,
} = toRefs(props);

const isOpen = ref(false);
const internalPopperOptions = computed(() => {
    return popperOptions.value || {
        gpuAcceleration: false,
        modifiers: [
            (data) => {
                data.offsets.popper.top = data.offsets.reference.top;
                data.offsets.popper.left = data.offsets.reference.left;
                return data;
            },
            'shift',
            (data) => {
                let offset = data.instance._options.offset;
                if (offset) {
                    if (typeof offset === 'number') {
                        offset = `${offset}px ${offset}px`;
                    }
                    const [ms, mt] = offset.split(/\s|\,/g)
                        .map(str => Number(str.trim()) || str.trim() || 0)
                        .map(numOrStr => typeof numOrStr === 'number' ? `${numOrStr}px` : numOrStr);
                    data.instance._popper.style['margin-left'] = ms;
                    data.instance._popper.style['margin-top'] = mt;
                }
                return data;
            },
            'preventOverflow',
            'flip',
            'applyStyle',
        ],
    };
});

watch(value, (newValue) => {
    isOpen.value = newValue;
});

const onChange = (value) => {
    emit('input', value);
    isOpen.value = value;
};


return { __sfc: true,props, emit, trigger, width, title, content, disabled, offset, transition, popperClass, openDelay, closeDelay, tabindex, popperOptions, value, placement, appendToBody, isOpen, internalPopperOptions, onChange }
}

})